<template>
  <div>
    <div class="vx-row">
      <vs-col v-if="todasAsEntidades" vs-lg="4" vs-md="4" vs-sm="12" class="vx-col mb-4">
        <div class="vx-row">
          <vs-col vs-w="12" class="vx-col">
            <span>Entidade:</span>
          </vs-col>
          <vs-col vs-w="12" class="vx-col">
            <entidade-select
              v-validate="'required'"
              name="entidade"
              v-model="parceiro.entidade"
              :clearable="false"
            ></entidade-select>
            <span
              class="text-danger text-sm"
              v-show="errors.has('entidade')"
            >{{ errors.first('entidade') }}</span>
          </vs-col>
        </div>
      </vs-col>
      <vs-col vs-lg="4" vs-md="6" vs-sm="12" class="vx-col mb-4">
        <div class="vx-row">
          <vs-col vs-w="12" class="vx-col">
            <span>Nome:</span>
          </vs-col>
          <vs-col vs-w="12" class="vx-col">
            <vs-input
              v-uppercase
              v-validate="'required'"
              class="w-full"
              name="nome"
              v-model="parceiro.nome"
            />
            <span class="text-danger text-sm" v-show="errors.has('nome')">{{ errors.first('nome') }}</span>
          </vs-col>
        </div>
      </vs-col>
      <vs-col vs-lg="4" vs-md="6" vs-sm="12" class="vx-col mb-4">
        <div class="vx-row">
          <vs-col vs-w="12" class="vx-col">
            <span>Razão Social:</span>
          </vs-col>
          <vs-col vs-w="12" class="vx-col">
            <vs-input
              v-uppercase
              class="w-full"
              name="razao_social"
              v-model="parceiro.razao_social"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('razao_social')"
            >{{ errors.first('razao_social') }}</span>
          </vs-col>
        </div>
      </vs-col>

      <vs-col vs-lg="4" vs-md="6" vs-sm="12" class="vx-col mb-4">
        <div class="vx-row">
          <vs-col vs-w="12" class="vx-col">
            <span>CPF/CNPJ:</span>
          </vs-col>
          <vs-col vs-w="12" class="vx-col">
            <vs-input v-uppercase class="w-full" name="cpf_cnpj" v-model="parceiro.cpf_cnpj" />
            <span
              class="text-danger text-sm"
              v-show="errors.has('cpf_cnpj')"
            >{{ errors.first('cpf_cnpj') }}</span>
          </vs-col>
        </div>
      </vs-col>
      <vs-col vs-lg="4" vs-md="6" vs-sm="12" class="vx-col mb-4">
        <div class="vx-row">
          <vs-col vs-w="12" class="vx-col">
            <span>CEP:</span>
          </vs-col>
          <vs-col vs-w="12" class="vx-col">
            <vs-input v-uppercase class="w-full" name="cep" v-model="parceiro.cep" />
            <span class="text-danger text-sm" v-show="errors.has('cep')">{{ errors.first('cep') }}</span>
          </vs-col>
        </div>
      </vs-col>

      <vs-col vs-lg="4" vs-md="6" vs-sm="12" class="vx-col mb-4">
        <div class="vx-row">
          <vs-col vs-w="12" class="vx-col">
            <span>Estado:</span>
          </vs-col>
          <vs-col vs-w="12" class="vx-col">
            <vs-input v-uppercase class="w-full" name="estado" v-model="parceiro.estado" />
            <span
              class="text-danger text-sm"
              v-show="errors.has('estado')"
            >{{ errors.first('estado') }}</span>
          </vs-col>
        </div>
      </vs-col>

      <vs-col vs-lg="4" vs-md="6" vs-sm="12" class="vx-col mb-4">
        <div class="vx-row">
          <vs-col vs-w="12" class="vx-col">
            <span>Cidade:</span>
          </vs-col>
          <vs-col vs-w="12" class="vx-col">
            <vs-input v-uppercase class="w-full" name="cidade" v-model="parceiro.cidade" />
            <span
              class="text-danger text-sm"
              v-show="errors.has('cidade')"
            >{{ errors.first('cidade') }}</span>
          </vs-col>
        </div>
      </vs-col>

      <vs-col vs-lg="4" vs-md="6" vs-sm="12" class="vx-col mb-4">
        <div class="vx-row">
          <vs-col vs-w="12" class="vx-col">
            <span>Bairro:</span>
          </vs-col>
          <vs-col vs-w="12" class="vx-col">
            <vs-input v-uppercase class="w-full" name="bairro" v-model="parceiro.bairro" />
            <span
              class="text-danger text-sm"
              v-show="errors.has('bairro')"
            >{{ errors.first('bairro') }}</span>
          </vs-col>
        </div>
      </vs-col>

      <vs-col vs-lg="4" vs-md="6" vs-sm="12" class="vx-col mb-4">
        <div class="vx-row">
          <vs-col vs-w="12" class="vx-col">
            <span>Rua:</span>
          </vs-col>
          <vs-col vs-w="12" class="vx-col">
            <vs-input v-uppercase class="w-full" name="rua" v-model="parceiro.rua" />
            <span class="text-danger text-sm" v-show="errors.has('rua')">{{ errors.first('rua') }}</span>
          </vs-col>
        </div>
      </vs-col>

      <vs-col vs-lg="4" vs-md="6" vs-sm="12" class="vx-col mb-4">
        <div class="vx-row">
          <vs-col vs-w="12" class="vx-col">
            <span>Número:</span>
          </vs-col>
          <vs-col vs-w="12" class="vx-col">
            <vs-input v-uppercase class="w-full" name="numero" v-model="parceiro.numero" />
            <span
              class="text-danger text-sm"
              v-show="errors.has('numero')"
            >{{ errors.first('numero') }}</span>
          </vs-col>
        </div>
      </vs-col>

      <vs-col vs-lg="4" vs-md="6" vs-sm="12" class="vx-col mb-4">
        <div class="vx-row">
          <vs-col vs-w="12" class="vx-col">
            <span>Complemento:</span>
          </vs-col>
          <vs-col vs-w="12" class="vx-col">
            <vs-input v-uppercase class="w-full" name="complemento" v-model="parceiro.complemento" />
            <span
              class="text-danger text-sm"
              v-show="errors.has('complemento')"
            >{{ errors.first('complemento') }}</span>
          </vs-col>
        </div>
      </vs-col>
      <vs-col vs-lg="4" vs-md="6" vs-sm="12" class="vx-col mb-4">
        <div class="vx-row">
          <vs-col vs-w="12" class="vx-col">
            <span>Anotações:</span>
          </vs-col>
          <vs-col vs-w="12" class="vx-col">
            <vs-input v-uppercase class="w-full" name="anotacoes" v-model="parceiro.anotacoes" />
            <span
              class="text-danger text-sm"
              v-show="errors.has('anotacoes')"
            >{{ errors.first('anotacoes') }}</span>
          </vs-col>
        </div>
      </vs-col>
    </div>
  </div>
</template>

<script>
import EntidadeSelect from "@/components/select/EntidadeSelect.vue";

export default {
  name: "editar-dados-parceiro",
  props: ["value"],
  components: {
    EntidadeSelect
  },
  inject: ["$validator"],
  data() {
    return {
      parceiro: {
        id: null
      }
    };
  },
  created() {
    this.parceiro = { ...this.value };
  },
  watch: {
    value(parceiro, oldParceiro) {
      if (parceiro.id !== oldParceiro.id) {
        this.parceiro = parceiro;
      }
    },
    parceiro: {
      handler(parceiro) {
        this.$emit("input", {
          id: parceiro.id,
          nome: parceiro.nome,
          razao_social: parceiro.razao_social,
          associacao: parceiro.associacao,
          associacao_id: parceiro.associacao ? parceiro.associacao.id : null,
          entidade: parceiro.entidade,
          entidade_id: parceiro.entidade ? parceiro.entidade.id : null,
          cpf_cnpj: parceiro.cpf_cnpj,
          cep: parceiro.cep,
          estado: parceiro.estado,
          cidade: parceiro.cidade,
          bairro: parceiro.bairro,
          rua: parceiro.rua,
          numero: parceiro.numero,
          complemento: parceiro.complemento,
          anotacoes: parceiro.anotacoes
        });
      },
      deep: true
    }
  }
};
</script>



